export default "__VITE_ASSET__BDc3o1Qe__"